import { render, staticRenderFns } from "./FileDetailsModal.vue?vue&type=template&id=429c85f5"
import script from "./FileDetailsModal.vue?vue&type=script&lang=js"
export * from "./FileDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports